import { Reducer } from 'redux';
import { SystemAction, SystemActionTypes } from './types';

export interface SystemState {
    readonly isFetching: boolean;
    readonly isPersisting: boolean;
    readonly savedChecksum: string;
}

export const defaultState: SystemState = {
    isFetching: false,
    isPersisting: false,
    savedChecksum: '',
};

export const systemReducer: Reducer<SystemState, SystemAction> = (state = defaultState, action: SystemAction) => {
    const cryptoJS = require('crypto-js');

    switch (action.type) {
        case SystemActionTypes.SYSTEM_FILE_LOAD_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case SystemActionTypes.SYSTEM_FILE_LOAD_FAILURE:
            return {
                ...state,
                isFetching: false,
            };
        case SystemActionTypes.SYSTEM_FILE_LOAD_SUCCESS:
            return {
                ...state,
                isFetching: false,
            };
        case SystemActionTypes.SYSTEM_PERSIST_REQUEST:
            return {
                ...state,
                isPersisting: true,
            };
        case SystemActionTypes.SYSTEM_PERSIST_FAILURE:
            return {
                ...state,
                isPersisting: false,
            };
        case SystemActionTypes.SYSTEM_PERSIST_SUCCESS:
            return {
                ...state,
                savedChecksum: cryptoJS.MD5(JSON.stringify(action.payload.system)),
                isPersisting: false,
            };

        default:
            return state;
    }
};
